import { Injectable } from '@angular/core';
import {Observable, Subject, throwError} from 'rxjs';
import {delay, finalize, map} from 'rxjs/operators';

import {HISTORY_KEY_HISTORY_PROVERB, SearchParam} from '../../defines/client.const';
import {CONTENT_TYPE_JSON_UTF8, PROVERB_IN_API_URL} from '../../defines/protocol';
import {Proverb} from '../../models/proverb.model';
import {SearchHistory} from '../../models/history.model';
import {ListLoader, ListLoader_NextList} from '../../interfaces/list-loader';
import {ApiService} from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class ProverbHistoryService implements ListLoader<Proverb> {
  private history: SearchHistory = null;

  private listProverb: Array<Proverb>;
  private mapProverb: Map<string, Proverb>;
  private load$: Observable<ListLoader_NextList<Proverb>> = null;


  constructor(
    private api: ApiService,
  ) {
    this.history = new SearchHistory({name: HISTORY_KEY_HISTORY_PROVERB});
  }

  public addHistory(id: string): void {
    this.history.addItem(id);
  }

  /******************************************************************************
   * ListLoader<SimpleProverb> 구현부
   *****************************************************************************/

  // TODO: 일단 페이지 없이 모두 로딩한다. 나중에 페이지 로딩 추가해야 함.
  // private nextPage: number;

  public getList(): Array<Proverb> {
    return this.listProverb;
  }

  public getCurCount(): number {
    console.log('ProverbHistoryService::getCurCount()');
    return (this.listProverb && this.listProverb.length) ?? 0;
  }

  public getTotalCount(): number {
    // console.log('ProverbHistoryService::getTotalCount()');
    return (this.history && this.history.list && this.history.size) ?? 0;
  }

  public IsComplete(): boolean {
    // console.log('ProverbHistoryService::IsComplete()');
    return this.history && (
      this.listProverb && this.listProverb.length === this.history.size ||
      this.history.empty()
    );
  }

  public IsLoading(): boolean {
    return this.load$ !== null;
  }

  public ResetList(param?: SearchParam): void {
    // console.log('ProverbHistoryService::ResetList()', param, this);
    this.listProverb = null;
    this.mapProverb = null;

    // this.nextPage = 0;
    if (param && 'id' in param) {
      this.addHistory(param.id);
    }
  }

  public getById(id: string): Proverb {
    return this.mapProverb.get(id) ?? null;
  }

  public GetNextList(): Observable<ListLoader_NextList<Proverb>> {
    console.log('ProverbHistoryService::GetNextList()', this);
    // 이미 다 로딩 했는지 확인
    // if (this.history.listHistory.length < this.nextPage * HISTORY_PAGE_SIZE) {
    if (this.IsComplete()) {
      return throwError({message: 'already load all proverbs in bookmark'});
    }
    else if (this.history && this.history.empty()) {
      // 이력이 없으면 서버에 요청하지 않고 처리한다.
      return new Observable<ListLoader_NextList<Proverb>>(observer => {
        observer.next({
          list: [],
          first: false,
        });
        observer.complete();
      }).pipe(delay(0));
    }

    if (this.load$ !== null) {
      return this.load$;
    }

    const url = PROVERB_IN_API_URL;
    return this.load$ = this.api.Post(url, {list: this.history.list}, null, CONTENT_TYPE_JSON_UTF8).pipe(
      finalize(() => {
        this.load$ = null;
      }),
      map((data: []) => {
        // if (this.nextPage === 0) {
        this.listProverb = new Array<Proverb>();
        // }

        const list = new Array<Proverb>();
        data.forEach(value => {
          const proverb = new Proverb(value);
          list.push(proverb);
          this.listProverb.push(proverb);
        });

        // return this.nextPage++ === 0;
        return {list, first: true};
      })
    );
  }
}
